<template>
	<PermissionsDashboard />
</template>
<script>
import PermissionsDashboard from '@/components/permissions/dashboard/index.vue';
export default {
	name: 'DashboardPermissionsPage',
	components: { PermissionsDashboard },
};
</script>
